<div class="winback-overlay">
  <div class="winback-modal" role="dialog" aria-modal="true" aria-labelledby="winback-title">
    <img class="winback-wordmark" src="assets/images/rosie-wordmark.svg" alt="Rosie" />

    <div class="winback-header">
      <div class="winback-eyebrow">Your {{ trialDays }}-day trial is reset</div>
      <h1 class="winback-title" id="winback-title">Welcome back.</h1>
      <div class="winback-subtitle">Rosie is smarter, has more capabilities, and 20 new integrations.</div>
    </div>

    <div class="winback-card-form">
      <div class="winback-card-title">Add a credit card to start your new trial.</div>

      <!-- Stripe iframes only fill the text line, so a tap on the padding
           focuses the element through the wrapper. -->
      <div class="winback-field winback-card-number" (click)="focusCard()">
        <div id="winback-card-number" class="winback-stripe-mount"></div>
        <span class="winback-placeholder" *ngIf="!cardNumberReady">Card number</span>
      </div>
      <div class="winback-card-row">
        <div class="winback-field" (click)="focusExpiry()">
          <div id="winback-card-expiry" class="winback-stripe-mount"></div>
          <span class="winback-placeholder" *ngIf="!cardExpiryReady">MM/YY</span>
        </div>
        <div class="winback-field" (click)="focusCvc()">
          <div id="winback-card-cvc" class="winback-stripe-mount"></div>
          <span class="winback-placeholder" *ngIf="!cardCvcReady">CVC</span>
        </div>
        <rosie-text class="winback-zip" [control]="zipControl" [autoExpand]="false"
          [placeholderTranslationKey]="'ZIP code'" [customClass]="'winback-zip-input'"
          [class.invalid]="submitAttempted && zipControl.invalid"></rosie-text>
      </div>

      <div class="winback-promo">
        <button type="button" class="winback-link-button winback-promo-toggle" *ngIf="promoState === 'collapsed'"
          (click)="expandPromo()">
          <ng-icon [name]="'heroTag'" [strokeWidth]="'1.5'"></ng-icon>
          Add promo code
        </button>
        <div class="winback-promo-field" *ngIf="promoState === 'expanded'">
          <rosie-text class="winback-promo-input" [control]="promoControl" [autoExpand]="false"
            [placeholderTranslationKey]="'Promo code'" (keyup.enter)="applyPromo()"></rosie-text>
          <rosie-button [translationKey]="'COMMON.APPLY'" [customClass]="'btn-secondary winback-promo-apply'"
            [fullWidth]="false" [customType]="'button'" [inProgress]="promoInProgress"
            (click)="applyPromo()"></rosie-button>
        </div>
        <div class="winback-promo-error" *ngIf="promoError">{{ promoError }}</div>
        <div class="winback-promo-applied" *ngIf="promoState === 'applied'">
          <ng-icon [name]="'heroTag'" [strokeWidth]="'1.5'"></ng-icon>
          <span>{{ appliedPromoName }}</span>
          <button type="button" class="winback-link-button" (click)="removePromo()">Remove</button>
        </div>
      </div>

      <rosie-alert *ngIf="cardError" [message]="cardError" [type]="'error'"></rosie-alert>
    </div>

    <div class="winback-cta-row">
      <div class="winback-terms">
        <ng-container *ngIf="monthlyPrice">Rosie Pro is {{ monthlyPrice.amount | rosieCurrency:false:true }}/month after
          your trial ends on {{ trialEndDate | date:'MMMM d, y' }}.&nbsp;</ng-container><a href="https://heyrosie.com/legal/terms" target="_blank" rel="noopener">Terms of Service</a>
      </div>
      <div class="winback-cta">
        <rosie-button [translationKey]="'WINBACK.CTA'" [customClass]="'btn-primary winback-cta-button'"
          [fullWidth]="false" [customType]="'button'" [inProgress]="inProgress"
          (click)="submit()"></rosie-button>
        <div class="winback-due-today">$0 due today</div>
      </div>
    </div>

    <div class="winback-footer" [class.single-action]="!hasMultipleBusinesses">
      <div class="winback-footer-action" *ngIf="hasMultipleBusinesses">
        <ng-icon [name]="'heroArrowsRightLeft'" [strokeWidth]="'1.5'"></ng-icon>
        <rosie-switch-account></rosie-switch-account>
      </div>
      <button type="button" class="winback-footer-action winback-link-button" (click)="logout()">
        <ng-icon [name]="'heroArrowRightStartOnRectangle'" [strokeWidth]="'1.5'"></ng-icon>
        Log out
      </button>
    </div>
  </div>
</div>
